import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Caracteristica } from '../../../../interfaces/caracteristica';
import { MatSelectChange, MatDatepickerInputEvent } from '@angular/material';
import { CaracteristicaService } from '../../../../providers/caracteristica.service';
import { TipoProducto } from '../../../../interfaces/tipo-producto';
import { Moment } from 'moment';
import { CaracteristicaValor } from '../../../../interfaces/valor-caracteristica';

@Component({
  selector: 'app-listar-caracteristicas',
  templateUrl: './listar-caracteristicas.component.html',
  styleUrls: ['./listar-caracteristicas.component.scss']
})
export class ListarCaracteristicasComponent {
  @Output() onChange = new EventEmitter();
  @Output() caracteristicasChange = new EventEmitter();
  cargando: boolean = true;

  // array de caracteristicas posibles según el tipo de producto (y su categoría)
  public _caracteristicasPosibles: Caracteristica[];

  // array de valores de las características, seleccionados para el producto cargado
  private _caracteristivasSeleccionadas: Caracteristica[];

  constructor(
    private caracteristicaService: CaracteristicaService
  ) { }

  // mostrar características del tipo de producto ingresado
  @Input() public set tipoProducto(tipoProducto: TipoProducto) {
    if (tipoProducto && tipoProducto.id) {
      this.cargando = true;
      this._caracteristicasPosibles = <Caracteristica[]>[];
      this.caracteristicaService.getCaracteristicas(
        {
          page: null,
          pageSize: null
        },
        {
          sort: 'descripcion',
          order: 'asc'
        },
        {
          IdTipoProducto: tipoProducto.id
        }
      ).subscribe(
        respuesta => {
          if (respuesta) {
            if (respuesta.estado && respuesta.estado == 1 && respuesta.data) {
              respuesta.data.forEach((caracteristica: Caracteristica) => {
                caracteristica.seleccionado = new CaracteristicaValor(); // crear un valor seleccionado vacio                
                this._caracteristicasPosibles.push(caracteristica);
              });
              this._actualizarValoresSeleccionados();
            }
          }

          this.cargando = false;
        },
        error => {
          this.cargando = false;
        }
      )
    }
  }

  // valores de las caracteristicas que son modificados en este componente
  @Input() public set caracteristicas(caracteristicas: Caracteristica[]) {
    this._caracteristivasSeleccionadas = caracteristicas;

    this._actualizarValoresSeleccionados();
  }

  // funcion general para todo tipo de input
  onInput(): void {
    this.onChange.emit();
  }

  // ya sea que cambie el input de características seleccionadas "@Input() public set caracteristicas"
  // o que cambie el listado de caracteristivas posibles "@Input() public set tipoProducto"
  // hay que setear los valores seleccionados a los valores posibles
  private _actualizarValoresSeleccionados(): void {
    if (this._caracteristicasPosibles) {
      // para cada caracteristica posible
      this._caracteristicasPosibles.forEach((caracteristicaPosible: Caracteristica, i: number) => {
        if (this._caracteristivasSeleccionadas) {
          // buscar si hay un valor seleccionado
          var index = this._caracteristivasSeleccionadas.length;
          while (index--) {
            var caracteristicaSeleccionada = this._caracteristivasSeleccionadas[index];
            if (caracteristicaSeleccionada.IdCaracteristica == caracteristicaPosible.IdCaracteristica) {
              // si hay un valor seleccionado lo asignamos a la caracteristica posible
              if (caracteristicaSeleccionada.seleccionado) {
                this._caracteristicasPosibles[i].seleccionado = caracteristicaSeleccionada.seleccionado;
                caracteristicaSeleccionada.tipoCaracteristica = this._caracteristicasPosibles[i].tipoCaracteristica;
                caracteristicaSeleccionada.ordenImpresion = this._caracteristicasPosibles[i].ordenImpresion;
              }

              break;
            }
          }
        }
      });
    }
  }

  // Input tipo: FECHA
  onInputFECHA(caracteristica: Caracteristica, event: MatDatepickerInputEvent<Moment>) {
    var valor = event.value;

    // crear nuevo valor seleccionado
    var caracteristicaSeleccionada = new CaracteristicaValor(
      caracteristica.seleccionado.IdCaracteristicaValor,
      valor.format("YYYY-MM-DD")
    );

    // setear el nuevo valor como seleccionado (en el array de seleccionadas)
    this._setCaracteristicaSeleccionada(caracteristica, caracteristicaSeleccionada);

    // informar al padre que hubo cambios
    this.onInput();
  }

  // Input tipo: NUMERO
  onInputNUMERO(caracteristica: Caracteristica, event: any) {
    this.onInputTEXTO(caracteristica, event);
  }

  // Input tipo: TEXTO
  onInputTEXTO(caracteristica: Caracteristica, event: any) {
    var valor = (<HTMLInputElement>event.target).value;

    // crear nuevo valor seleccionado
    var caracteristicaSeleccionada = new CaracteristicaValor(
      caracteristica.seleccionado.IdCaracteristicaValor,
      valor
    );

    // setear el nuevo valor como seleccionado (en el array de seleccionadas)
    this._setCaracteristicaSeleccionada(caracteristica, caracteristicaSeleccionada);

    // informar al padre que hubo cambios
    this.onInput();
  }

  // Input tipo: OPCIONES
  onInputOPCIONES(caracteristica: Caracteristica, event: MatSelectChange) {
    var valor = <CaracteristicaValor>event.value;

    // crear nuevo valor seleccionado
    var caracteristicaSeleccionada = new CaracteristicaValor(
      valor.IdCaracteristicaValor,
      valor.descripcion
    );

    // setear el nuevo valor como seleccionado (en el array de seleccionadas)
    this._setCaracteristicaSeleccionada(caracteristica, caracteristicaSeleccionada);

    // informar al padre que hubo cambios
    this.onInput();
  }

  compararTipoOpcion(op1: CaracteristicaValor, op2: CaracteristicaValor): boolean {
    if (op1 && op2) {
      return op1.IdCaracteristicaValor == op2.IdCaracteristicaValor;
    }

    return false;
  }

  clearCaracteristicaSeleccionada(caracteristica: Caracteristica): void {
    // setear el nuevo valor como seleccionado (en el array de seleccionadas)
    this._setCaracteristicaSeleccionada(caracteristica, null);

    // informar al padre que hubo cambios
    this.onInput();
  }

  private _setCaracteristicaSeleccionada(caracteristica, seleccionada: CaracteristicaValor): void {
    // actualizar valor de la caracteristica seleccionada correspondiente
    var caracteristicaModificada = false;
    this._caracteristivasSeleccionadas.forEach((caracteristicaSeleccioanda: Caracteristica, index: number) => {
      if (caracteristicaSeleccioanda.IdCaracteristica == caracteristica.IdCaracteristica) {
        this._caracteristivasSeleccionadas[index].tipoCaracteristica = caracteristica.tipoCaracteristica;
        this._caracteristivasSeleccionadas[index].seleccionado = seleccionada;
        this._caracteristivasSeleccionadas[index].ordenImpresion = caracteristica.ordenImpresion;
        caracteristicaModificada = true;
      }
    });

    // si la caracteristica no estaba entre las seleccionadas
    // la seleccionamos con su respectivo valor ingresado
    if (!caracteristicaModificada) {
      this._caracteristivasSeleccionadas.push(new Caracteristica(
        caracteristica.IdCaracteristica,
        caracteristica.descripcion,
        caracteristica.valores,
        seleccionada,
        caracteristica.tipoCaracteristica,
        null,
        caracteristica.ordenImpresion
      ));
    }

    // actualizar listado de caracteristicas del padre
    this.caracteristicasChange.emit(this._caracteristivasSeleccionadas);
  }
}
